export const LAST_SAVED_FALLBACK_LABEL = "Not yet saved";

export function normalizeLastSavedName(name: string | null | undefined): string | null {
    if (typeof name !== "string") {
        return null;
    }

    const trimmed = name.trim();
    if (trimmed.length === 0) {
        return null;
    }

    if (trimmed.localeCompare(LAST_SAVED_FALLBACK_LABEL, undefined, { sensitivity: "accent" }) === 0) {
        return null;
    }

    return trimmed;
}

export function hasLastSavedMetadata(
    timestamp: string | null | undefined,
    name: string | null | undefined,
): boolean {
    return !!timestamp && !!normalizeLastSavedName(name);
}
